import clsx from 'clsx';
import React, { forwardRef, memo } from 'react';
import { Typography } from '../typography';
import styles from './styles.module.css';
import { usePrice } from './use-price';
import { colorToken, useStyleProps } from '../utils';
/**
 * `<Price>` - Компонент для вывода цены.
 * @example ```tsx
 <Price value={12345.67} fraction units="₽/шт" />
 * ```
 */
export const Price = /*#__PURE__*/memo(/*#__PURE__*/forwardRef((props, ref) => {
  const {
    integer,
    decimals,
    showFraction,
    integerProps,
    fractionProps,
    unitsProps,
    prefixProps
  } = usePrice(props);
  const {
    className,
    align = 'left',
    size = 'm',
    oldPriceMarker = false,
    oldPriceMarkerColor,
    children,
    fraction,
    inline = false,
    units = '₽',
    prefixText,
    ...rest
  } = props;
  const wrapperClassName = clsx(className, styles.wrapper, styles[align], {
    [styles.inline]: inline
  });
  const fractionClassName = clsx(styles.priceFraction);
  const priceClassName = clsx(styles.price, {
    [styles.oldPriceMarker]: oldPriceMarker,
    [styles.shortIndent]: size === 'xxs' || size === 'xs'
  });
  const oldPriceMarkerStyle = useStyleProps({
    color: oldPriceMarkerColor
  }, oldPriceStyleProps);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    ref: ref,
    ...rest
  }, /*#__PURE__*/React.createElement("span", {
    className: priceClassName,
    "data-testid": "price",
    ...oldPriceMarkerStyle
  }, !!prefixText && (/*#__PURE__*/React.createElement(Typography, {
    "data-testid": "price-prefix",
    ...prefixProps
  }, prefixText)), !!prefixText && ' ', /*#__PURE__*/React.createElement(Typography, {
    className: styles.priceInteger,
    "data-testid": "price-integer",
    ...integerProps
  }, integer), showFraction && (/*#__PURE__*/React.createElement(Typography, {
    "data-testid": "price-fraction",
    className: fractionClassName,
    ...fractionProps
  }, ', ', decimals)), /*#__PURE__*/React.createElement(Typography, {
    className: clsx(styles.priceUnit, styles[`priceUnitSize${size}`]),
    "data-testid": "price-unit",
    overrideStyles: false,
    ...unitsProps
  }, ' ', units)), children);
}));
const oldPriceStyleProps = {
  color: ['color', colorToken]
};